import { actionGenerator, IReduxAction } from '../../utils/actions';
import { IUserState } from '../../types/reducers/user';

export const SET_USER = 'USER :: SET_USER';

export type TSetUserPayload = IUserState;

export type TSetUserAction = IReduxAction<typeof SET_USER, TSetUserPayload>;

export const setUser = actionGenerator<typeof SET_USER, TSetUserPayload>(SET_USER);
